import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { LogsService } from './logs.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'nrwl-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss']
})
export class LogsComponent implements OnInit, OnDestroy {
  grafanaErroMsg = 'Logs view disabled by system administrator';
  grafanaAppURL = '/grafana/public-dashboards/8df8bfacc8064eb7ae5e8e525b368fcf';
  grafanaEnabled = false;
  grafanaConfig: any;
  srcSafeURL: SafeResourceUrl;
  showLogs = true;
  private readonly unsubscribe: Subject<void> = new Subject();
  constructor(
    public sanitizer: DomSanitizer,
    private logsService: LogsService,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    this.getGrafanaConfig();
  }

  getGrafanaConfig(): void {
    this.logsService
      .getLogsConfig$()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        if (response && response.data && response.data['grafana']) {
          this.grafanaConfig = response.data['grafana'];
          this.embedGrafanaLogs();
        }
      });
  }

  embedGrafanaLogs(): void {
    if (this.grafanaConfig && this.grafanaConfig.enabled) {
      this.grafanaEnabled = this.grafanaConfig.enabled;
      let logsURL =
        this.grafanaConfig.protocol + '://' + this.grafanaConfig.hostname + this.grafanaAppURL;
      if (this.grafanaConfig.basepath && this.grafanaConfig.basepath !== '') {
        logsURL = this.grafanaConfig.basepath + this.grafanaAppURL;
      }
      this.srcSafeURL = this.sanitizer.bypassSecurityTrustResourceUrl(logsURL);
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.showLogs = false;
    this.elementRef.nativeElement.remove();
  }
}
